import { Box, Button, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

import { useHideLayoutChrome } from "@/layout/MainLayout/LayoutChromeContext";
import Logo from "@/shared/ui/Logo";

import useStyles from "./NotFoundPage.styles";

const NotFoundPage = () => {
  const { classes, cx } = useStyles();
  const { pathname } = useLocation();

  useHideLayoutChrome();

  return (
    <Box component="main" className={classes.root}>
      <Link to="/" className={classes.brand} aria-label="Mafia home">
        <Logo classNames={classes.brandLogo} />
        <span className={classes.brandName}>MAFIA</span>
      </Link>

      <Box className={classes.content}>
        <div className={classes.code} aria-hidden="true">
          <span className={cx(classes.digit, classes.digitLeft)}>4</span>
          <span className={classes.medallion}>
            <Logo classNames={classes.medallionImage} />
          </span>
          <span className={cx(classes.digit, classes.digitRight)}>4</span>
        </div>

        <Typography component="h1" className={classes.title}>
          Page not found
        </Typography>

        <Typography className={classes.description}>
          Nothing lives at <code className={classes.path}>{pathname}</code>.
          The link may be out of date, or the address has a typo.
        </Typography>

        <Box className={classes.actions}>
          <Button component={Link} to="/" className={classes.primary}>
            Go to home
          </Button>
          <Button component={Link} to="/map" className={classes.secondary}>
            Open city map
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NotFoundPage;
